/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2018 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H217483 on 2/12/2019.
 */

import React from 'react'
import {withRouter} from 'react-router'
import {connect} from 'react-redux'
import {injectIntl} from 'react-intl';
import {ACTIVITY_TYPES} from "../security/SecurityConst";
import {userHasActivity} from "../security/SecurityUtils";
import {Button, Grid} from "@scuf/common";
import {Routes} from "../utils/Routes";

class DashboardHeader extends React.Component {
    render() {
        const {intl, history} = this.props
        return (
            <Grid className="dashboard-header">
                <Grid.Row>
                    <Grid.Column width={3} sWidth={12} sOrder={1}>
                        <h2>{this.props.userProfile.displayName}</h2>
                    </Grid.Column>
                    <Grid.Column width={5} sWidth={12} sOrder={3}>
                        {this.props.topChildren}
                    </Grid.Column>
                    <Grid.Column width={4} sWidth={12} sOrder={5}>
                        <div className="right-on-computer">
                            {userHasActivity(this.props.userProfile, ACTIVITY_TYPES.ASSIGNED_ISSUES_WRITE) ?
                                <Button
                                    className="mobile-max-width-button"
                                    content={intl.formatMessage({id: 'page.faultNew'})}
                                    onClick={() => history.push(Routes.FAULT_NEW)}/>
                                :
                                ''
                            }
                        </div>
                    </Grid.Column>
                    <Grid.Column width={3} sWidth={12} sOrder={2}>
                        {this.props.subtitle}
                    </Grid.Column>
                    <Grid.Column width={12} sWidth={12} sOrder={4}>
                        {this.props.bottomChildren}
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        userProfile: state.security.userProfile,
    }
}

export default injectIntl(withRouter(connect(mapStateToProps)(DashboardHeader)))